import { API_URL } from "@/config.tsx";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/** Загрузка корзины */
export const cartOfferLoader = createAsyncThunk(
    'cart/cartOfferLoading',
    async (args: { cartId: number, isMini: boolean, all?: boolean }, { rejectWithValue }) => {
        return await axios.get(`${API_URL}/cart/${args.cartId}/offer?isMini=${Number(args.isMini)}`,
            { withCredentials: true })
            .then(response => response.data)
            .then(data => ({data: {...data}, isMini: args.isMini, all: args.all || false}))
            .catch(error => rejectWithValue(error));
    }
);
